(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


<!-- Custom CSS -->
// Custom JS for menu

/*
function updateSubmenuColumnsWidth() {
    const menuLinks = document.querySelectorAll(
        '.menu-btn-wrap .inner-menu-wrap .menu-list .menu-list-item > a'
    );
    const submenuColumns = document.querySelector('.submenu-columns');

    if (!menuLinks.length || !submenuColumns) return;

    let maxWidth = 0;

    menuLinks.forEach(link => {
        const width = link.offsetWidth;
        if (width > maxWidth) {
            maxWidth = width;
        }
    });

    const offset = 30; // extra spacing
    const totalOffset = maxWidth + offset;

    // Apply styles
    submenuColumns.style.left = `${totalOffset}px`;
    submenuColumns.style.width = `calc(100% - ${totalOffset}px)`;
}
*/

function updateSubmenuColumnsWidth() {
    const menuLinks = document.querySelectorAll(
        '.menu-block .menu-list .menu-list-item > a'
    );
    // Use querySelectorAll to get EVERY submenu
    const allSubmenuColumns = document.querySelectorAll('.submenu-columns');

    if (!menuLinks.length || !allSubmenuColumns.length) return;

    let maxWidth = 0;

    // 1. Calculate the widest link first
    menuLinks.forEach(link => {
        const width = link.offsetWidth;
        if (width > maxWidth) {
            maxWidth = width;
        }
    });

    const offset = 30; // extra spacing
    const totalOffset = maxWidth + offset;

    // 2. Loop through every submenu and apply the styles
    allSubmenuColumns.forEach(submenu => {
        submenu.style.left = `${totalOffset}px`;
        submenu.style.width = `calc(100% - ${totalOffset}px)`;
    });
}


const menuBtn = document.querySelector('.menu-btn-wrap a');
const logoP = document.querySelector('.header__heading-logo-wrapper p');
const logoWrap = document.querySelector('.header__heading-logo-wrapper');
const innerMenu = document.querySelector('.menu-btn-wrap .inner-menu-wrap');
const headerIcons = document.querySelector('.header__icons');
const pageTitle = document.querySelector('.inner-page-title');

// Check for logo width
function updateMenuParaWidth() {
  // Apply width to .header__heading-link (full block width)
  const headingLink = document.querySelector('.header__heading-link');
  const icons = document.querySelector('.header__icons');
  const iconsWidth = icons.offsetWidth + 'px';
  //if ($('.header__heading-logo-wrapper').hasClass('open')) {
  if (document.querySelector('.header__heading-logo-wrapper')?.classList.contains('open')) {
    if (headingLink) {
        headingLink.style.width = iconsWidth;
    }
  }else{
      headingLink.style.width = "";
    }
}

menuBtn.addEventListener('click', function (e) {

    // Check if the clicked element has the class 'must-link'
    if (this.classList.contains('must-link')) {
        // Let it behave as a normal link
        return; // exit the function, don't prevent default
    }

    e.preventDefault();

    menuBtn.classList.toggle('active');
    const header = document.querySelector('sticky-header');
    header.classList.toggle('open');

    if (innerMenu.classList.contains('hide')) {
        // === INSTANT SHOW ===
        innerMenu.classList.remove('hide');
        innerMenu.style.display = 'flex';
        innerMenu.style.height = 'auto';
        innerMenu.style.overflow = '';

        // 👉 APPLY WIDTH
        const iconsWidth = headerIcons.offsetWidth;
        innerMenu.style.width = iconsWidth + 'px';

        logoWrap.classList.add('open');

        logoP.style.display = 'inline';
        logoP.style.opacity = 1;

        if (pageTitle) {
          pageTitle.style.display = 'none';
        }

        updateSubmenuColumnsWidth();
        updateMenuParaWidth();

    } else {
        // === INSTANT HIDE ===
        logoP.style.display = 'none';
        logoP.style.opacity = 0;

        logoWrap.classList.remove('open');

        innerMenu.style.display = 'none';
        innerMenu.classList.add('hide');
        innerMenu.style.height = '';
        innerMenu.style.overflow = '';
        innerMenu.style.width = '';

        if (pageTitle) {
          pageTitle.style.display = 'block';
        }

        updateMenuParaWidth();

    }
});

window.addEventListener('resize', () => {
    if (!innerMenu.classList.contains('hide')) {
        innerMenu.style.width = headerIcons.offsetWidth + 'px';
        updateSubmenuColumnsWidth();
    }
});

document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".menu-list-item.has-submenu");

  items.forEach(item => {
    const submenu = item.querySelector(".submenu");

    item.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      submenu.classList.toggle("open");

      item.classList.toggle("open");
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const popup = document.querySelector(".mobile-menu-popup-main");
  const openBtn = document.getElementById("open-popup-menu");
  const closeBtn = document.getElementById("close-popup-menu");

  // Open
  openBtn.addEventListener("click", function () {
    popup.classList.add("active");
  });

  // Close
  closeBtn.addEventListener("click", function () {
    popup.classList.remove("active");
  });

});


function updateWidths() {
    // Only run on screens wider than 768px
    if (window.innerWidth <= 768) {
        return;
    }

    const galleries = document.querySelectorAll('.custom-gallery');

    // Get the header icon width (4.4rem → px)
    const icon = document.querySelector('.header__icon, .header__icon--cart .icon');
    let iconWidth = 0;
    if (icon) {
        const iconStyles = window.getComputedStyle(icon);
        iconWidth = parseFloat(iconStyles.width); // px
    }

    /*
    galleries.forEach(gallery => {
        const blocks = gallery.querySelectorAll('.custom-gallery__block');

        // Only count visible desktop blocks
        const desktopBlocks = [...blocks].filter(
            block => !block.classList.contains('hide-desktop')
        );

        const blockCount = blocks.length;

        if (blockCount === 3) {
            const blockWidth = blocks[0].offsetWidth;

            // Apply width to .menu-btn-wrap (subtract icon)
            const menuBtn = document.querySelector('.menu-btn-wrap');
            if (menuBtn) {
                menuBtn.style.width = (blockWidth - iconWidth - 2) + 'px'; // Hard coded 2px to match the grid due to gap 
            }

            // Apply width to .header__heading-link (full block width)
            const headingLink = document.querySelector('.header__heading-link');
            if (headingLink) {
                headingLink.style.width = blockWidth + 'px';
            }
        }
    });
    */

    galleries.forEach(gallery => {
        const blocks = gallery.querySelectorAll('.custom-gallery__block');

        // Only count visible desktop blocks
        const desktopBlocks = [...blocks].filter(
            block => !block.classList.contains('hide-desktop')
        );

        const blockCount = desktopBlocks.length;

        if (blockCount === 3) {
            const blockWidth = desktopBlocks[0].offsetWidth;

            // Apply width to .menu-btn-wrap (subtract icon)
            const menuBtn = document.querySelector('.menu-btn-wrap');
            if (menuBtn) {
                menuBtn.style.width = (blockWidth - iconWidth - 2) + 'px';
            }

            // Apply width to .header__heading-link (full block width)
            const headingLink = document.querySelector('.header__heading-link');
            if (headingLink) {
                headingLink.style.width = blockWidth + 'px';
            }
        }
    });

}

function updateWidthsFromProductInfo() {
    // Only run on screens wider than 768px
    if (window.innerWidth <= 768) {
        return;
    }

    const productInfo = document.querySelector('.product__info-wrapper.grid__item');
    if (!productInfo) {
        return;
    }

    // Get width source
    const blockWidth = productInfo.offsetWidth;

    // Get the header icon width
    const icon = document.querySelector('.header__icon, .header__icon--cart .icon');
    let iconWidth = 0;

    if (icon) {
        const iconStyles = window.getComputedStyle(icon);
        iconWidth = parseFloat(iconStyles.width);
    }

    /* ✅ MOBILE LOGIC — nothing else touched */
    if (window.innerWidth <= 768) {
        const halfViewportWidth = window.innerWidth / 2;

        const menuBtn = document.querySelector('.menu-btn-wrap');
        if (menuBtn) {
            menuBtn.style.width = (halfViewportWidth - iconWidth) + 'px'; // Hard coded 26 pixels
            menuBtn.classList.add('in-product'); // ✅ added class
        }
        return;
    }
    /* ------------------------------------ */

    // Apply width to .menu-btn-wrap (subtract icon)
    const menuBtn = document.querySelector('.menu-btn-wrap');
    if (menuBtn) {
        menuBtn.style.width = (blockWidth - iconWidth) + 'px'; // Hard coded 3px for now
    }

    // Apply width to .header__heading-link (full block width)
    const headingLink = document.querySelector('.header__heading-link');
    if (headingLink) {
        headingLink.style.width = blockWidth + 'px';
    }

}

function updateWidthsFromHiddenSection() {

    // Only run on screens wider than 768px
    if (window.innerWidth <= 768) {
        return;
    }

    const hiddenSection = document.querySelector('.hidden-width-section');
    if (!hiddenSection) {
        return;
    }

    const widthCol = hiddenSection.querySelector('.width-col');
    if (!widthCol) {
        return;
    }

    // Get width source
    const blockWidth = widthCol.offsetWidth;

    // Get the header icon width
    const icon = document.querySelector('.header__icon, .header__icon--cart .icon');
    let iconWidth = 0;

    if (icon) {
        const iconStyles = window.getComputedStyle(icon);
        iconWidth = parseFloat(iconStyles.width);
    }

    // Apply width to .menu-btn-wrap (subtract icon)
    const menuBtn = document.querySelector('.menu-btn-wrap');
    if (menuBtn) {
        menuBtn.style.width = (blockWidth - iconWidth) + 'px'; // Hard coded 3px for now
    }

    // Apply width to .header__heading-link (full block width)
    const headingLink = document.querySelector('.header__heading-link');
    if (headingLink) {
        headingLink.style.width = blockWidth + 'px';
    }

}

function runWidthUpdates() {
    updateWidths();
    updateWidthsFromProductInfo();
    updateWidthsFromHiddenSection();
}

// Run on load and resize
window.addEventListener('load', runWidthUpdates);
window.addEventListener('resize', runWidthUpdates);


// Redirect Wholesale users
document.addEventListener('DOMContentLoaded', () => {
  const path = window.location.pathname;

  // Only act on /account page
  if (path === '/account' || path === '/account/') {
    // Check if the page has the logout link (indicates logged in)
    if (document.querySelector('a[href="/account/logout"]')) {
      // Redirect logged-in user to wholesale page
      window.location.href = '/pages/wholesale';
    }
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
